// extracted by mini-css-extract-plugin
export var footer = "_mh-5";
export var fulfillmentInput = "_mh-0";
export var shipDateInput = "_mh-1";
export var shipmentModal = "_mh-2";
export var shipmentModalContent = "_mh-3";
export var tableContainer = "_mh-4";